import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";

// Centralized i18next bootstrap. Imported once from src/index.js so any
// component can call `useTranslation()` afterwards.
//
// Translation strategy:
// - All NEW user-visible strings go through `t("key")`.
// - Existing English-language strings can be migrated incrementally; the
//   `fallbackLng: "en"` plus the en bundle below means missing keys still
//   render English.
// - Add a new locale by dropping `src/common/i18n/locales/<lng>.json` and
//   importing it here.
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
    },
    fallbackLng: "en",
    supportedLngs: ["en"],
    interpolation: {
      // React escapes interpolated values inside JSX automatically.
      // Translation strings themselves MUST stay developer-controlled
      // (only files under src/common/i18n/locales/) - never source them
      // from API responses or user input, because i18next would render
      // them as raw HTML and bypass React's escaping.
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
  });

export default i18n;
